import React from 'react';
import { FaDownload } from 'react-icons/fa';
import { motion } from 'framer-motion';
import profileImg from '../assets/Profile.png';

export default function Hero() {
  const [isScrolled, setIsScrolled] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section id="home" className="relative min-h-screen bg-transparent overflow-hidden font-['Lora'] flex items-center justify-center">
      {/* Top Left Logo - Fixed to viewport */}
      <div className="fixed top-6 left-6 sm:top-8 sm:left-24 z-50">
        <h2 className="text-xl sm:text-2xl font-bold text-white font-['Lora'] tracking-tight">
          Devinda<span className="text-[#4779c4]">.</span>
        </h2>
      </div>

      {/* Subtle Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full">
        <div className="absolute top-1/4 -left-32 sm:-left-40 w-80 sm:w-96 h-80 sm:h-96 bg-[#4779c4]/10 rounded-full blur-[120px] opacity-20"></div>
        <div className="absolute bottom-1/4 -right-32 sm:-right-40 w-80 sm:w-96 h-80 sm:h-96 bg-[#4779c4]/10 rounded-full blur-[120px] opacity-20"></div>
      </div>

      {/* Hero Content - Centered Vertical Layout */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 flex flex-col items-center justify-start text-center pt-32 lg:pt-40">
        
        {/* Text Content (Top) */}
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="space-y-6 max-w-4xl z-20"
        >
          <div className="space-y-4">
            <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold text-white leading-tight font-['Lora']">
              Wishmitha
              <span className="block text-[#4779c4]">Devinda</span>
            </h1>

            <div className="space-y-1">
              <p className="text-xs sm:text-sm md:text-base text-[#4779c4] font-semibold tracking-[0.4em] uppercase">
                Undergraduate
              </p>
              <p className="text-slate-400 text-xs sm:text-sm md:text-base font-light tracking-wider">
                Bachelor of Computer Science
              </p>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
            <a
              href="/CV%20PRO.pdf"
              download
              className="group px-8 py-3.5 bg-[#4779c4] rounded-full font-bold text-white 
                       hover:bg-[#3c649f] transition-all duration-300
                       flex items-center justify-center gap-3 font-['Lora'] text-base shadow-[0_0_20px_rgba(71,121,196,0.3)] hover:shadow-[0_0_30px_rgba(71,121,196,0.5)]"
            >
              <FaDownload className="w-4 h-4 group-hover:translate-y-0.5 transition-transform" />
              <span>Download CV</span>
            </a>
            
            <a
              href="#contact"
              className="px-8 py-3.5 rounded-full font-bold text-white border border-white/10
                       bg-white/5 hover:bg-white/10 backdrop-blur-md transition-all duration-300
                       flex items-center justify-center font-['Lora'] text-base"
            >
              Let's Talk
            </a>
          </div>
        </motion.div>

        {/* The Arch Shape Image (Under Text) */}
        <motion.div 
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          className="relative mt-16 sm:mt-24"
        >
          <div className="relative w-[260px] h-[350px] sm:w-[350px] sm:h-[480px]">
            {/* The Arch Shape Container */}
            <div className="relative w-full h-full bg-gradient-to-b from-[#2c456b] to-[#1b2d48] rounded-t-[200px] sm:rounded-t-[300px] rounded-b-[40px] overflow-hidden border border-[#4779c4]/20 shadow-2xl">
              
              {/* Inner Glow/Gradient - Matching Web Theme */}
              <div className="absolute inset-0 bg-gradient-to-b from-[#4779c4]/30 via-[#4779c4]/5 to-transparent"></div>
              
              {/* Decorative Rings */}
              <div className="absolute top-10 left-1/2 -translate-x-1/2 w-[120%] h-[120%] border border-[#4779c4]/10 rounded-full -z-0"></div>

              {/* Profile Image - Precisely Centered inside the shape */}
              <div className="absolute inset-0 flex items-end justify-center overflow-hidden">
                <img 
                  src={profileImg} 
                  alt="Wishmitha Devinda" 
                  className="max-w-none h-[95%] w-auto object-contain z-10 transition-transform duration-700 hover:scale-110 sm:translate-x-8 translate-x-5" 
                  onError={(e) => {
                    e.target.src = "https://via.placeholder.com/600x800?text=Profile";
                  }}
                />
              </div>
            </div>

            {/* Background Glow */}
            <div className="absolute inset-0 bg-[#4779c4]/10 blur-[80px] -z-10 rounded-full animate-pulse"></div>
          </div>
        </motion.div>

      </div>



      {/* Bottom Indicator */}
      {!isScrolled && (
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce opacity-40">
          <div className="w-6 h-10 border-2 border-slate-600 rounded-full flex justify-center">
            <div className="w-1.5 h-3 bg-[#4779c4] rounded-full mt-2"></div>
          </div>
        </div>
      )}
    </section>
  );
}

